@if (countdown) {
  <div class="idle-logout-warning text-center pv-5 ph-10 c-white fs-default fw-bold">
    Because of inactivity you will be logged out in {{ countdown }} seconds. Click anything to prevent.
  </div>
}
